import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router';

import useUserPublisherInfo from '../../store/models/user/useUserPublisherInfo';
import HeroSection from './heroSection';
import ListingSection from './listingSection';
import FeaturedPlacementSection from './featuredPlacementSection';
import GoodToKnowSection from './goodToKnowSection';
import useEcalWorldAsDev from './useEcalWorldAsDev';
import { useStyles } from './styles';

function isIntercomAvailable () {
    return typeof window.Intercom === 'function';
}

function EcalWorld () {
    const { publisher } = useUserPublisherInfo();
    const classes = useStyles();
    const history = useHistory();
    const { devAccess } = useEcalWorldAsDev();
    const listingRef = useRef(null);

    function scrollToListing () {
        if (!listingRef.current) {
            return;
        }
        // Offset for the fixed app header (~64px) so the listing section lands
        // just below it instead of being scrolled underneath.
        const OFFSET = 66;
        const top = listingRef.current.getBoundingClientRect().top + window.pageYOffset - OFFSET;
        window.scrollTo({ top, behavior: 'smooth' });
    }

    function handleFeaturedRequestClick () {
        history.push('/admin/marketing/ecal-world/request-to-be-featured');
        if (isIntercomAvailable()) {
            window.Intercom('update', {
                user_id: publisher?.publisherId,
                email: publisher?.email,
                user_hash: publisher?.intercomUserHash,
                ecal_world_to_be_featured: true,
            });
            window.Intercom('showNewMessage');
        }
    }

    // Temporarily only allow developers to access this.
    if (!devAccess) {
        return null;
    }

    return (
        <div className={classes.page}>
            <HeroSection
                onManageListing={scrollToListing}
                onRequestFeatured={handleFeaturedRequestClick}
            />

            <ListingSection
                publisher={publisher}
                sectionRef={listingRef}
            />

            <FeaturedPlacementSection
                onRequestFeatured={handleFeaturedRequestClick}
            />

            <GoodToKnowSection />
        </div>
    );
}

const ObservedEcalWorld = observer(EcalWorld);
export default ObservedEcalWorld;
